import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import dateTimeFilters from './filters/dateTimeFilters';
import htmlFilters from './filters/htmlFilters';
import numberFilters from './filters/numberFilters';
import VCalendar from 'v-calendar';
import vueDebounce from 'vue-debounce';
import { VueSpinners } from '@saeris/vue-spinners';

store.dispatch("config/initialize").then(() => {

    // check if the currently loaded client application is the same as what the
    // server reports is the latest version.  If different, attempt a force reload
    // of the page (works on some browsers, but the forceReload bool has been
    // deprecated and not all browsers support it, use in conjunction with html
    // level caching on the client hosting server)

    // api.getVersion().then((r) => {
    //   var currentVersion = 0;
    //   var ls = localStorage.getItem("clientVersion");
    //   if (ls) {
    //     currentVersion = parseInt(ls);
    //   }
    //   var serverVersion = parseInt(r.data);
    //   if (currentVersion !== serverVersion) {
    //     localStorage.setItem("clientVersion", serverVersion);
    //     window.location.reload(true);
    //   }
    //   setup();
    // });

    function setup() {
        // CSS imports
        require('./assets/css/s000-base.css');
        require('./assets/css/s010-site-header-footer.css');
        require('./assets/css/s040-content.css');
        require('./assets/css/s050-boardlist.css');
        require('./assets/css/s060-topicslists.css');
        require('./assets/css/s070-post-components.css');
        require('./assets/css/s080-post-content.css');
        require('./assets/css/s090-profile.css');
        require('./assets/css/s100-forms.css');
        require('./assets/css/s110-widgets.css');
        require('./assets/css/s120-messages.css');
        require('./assets/css/s130-notifications.css');
        require('./assets/css/s140-admin.css');
        require('./assets/css/s150-auth.css');
        require('./assets/css/s160-static.css');


        Vue.config.productionTip = true;

        Vue.use(VCalendar, {
          componentPrefix: 'vc',
        });

        Vue.use(vueDebounce);
        Vue.use(VueSpinners);


        dateTimeFilters.configure();
        htmlFilters.configure();
        numberFilters.configure();

        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');

    }
    setup();
});
